require('./simple_spinner.js');
require('../../assets/stylesheets/simple_spinner.scss');
